import React, { useState, useEffect } from 'react';
import axios from '../../../axios/index';
import { Link } from "react-router-dom";

// styles
import styles from "./Footer.module.css"

// img
import logo from "../../../assets/img/AzarMelk.png"
import telIcon from "../../../assets/img/HomePage/IconTelegram.svg"
import instaIcon from "../../../assets/img/HomePage/IconInstagram.svg"
import eenamad from "../../../assets/Logo1.png"
import eenamad2 from "../../../assets/Logo2.png"


const Footer = ({ style }) => {
    const [data, setData] = useState([])

    useEffect(() => {
        const dataHandler = async () => {
            const getSiteSettings = await axios.get("SiteSetting");
            const data = await getSiteSettings.data.data;
            setData(data)
        }

        dataHandler()
    }, [])

    return (
        <>
            <footer
                className={`vw-100 d-flex justify-content-center flex-wrap align-items-center mt-5 py-3 ${styles.footer_container}`}
                dir="rtl"
                style={style}
            >
                <div className={`d-grid align-items-center justify-content-md-evenly justify-content-center row ${styles.footer_content}`}>
                    <div className={`d-flex flex-column align-items-md-start align-items-center justify-content-center mb-md-0 mb-4 ${styles.logo_container}`}>
                        <img className='mb-4' src={logo} alt="لوگو آذر ملک" />
                        <div className={styles.description_text}>
                            {data?.footerText}
                        </div>
                        <div className="d-flex align-items-center justify-content-center mt-4">
                            <img src={eenamad} alt="اینماد" className={`ms-3 ${styles.icon_img}`} />
                            <img src={eenamad2} alt="ساماندهی" className={`ms-3 ${styles.icon_img}`} />
                        </div>
                    </div>
                    <div className={`d-flex align-items-end justify-content-start mb-md-0 mb-3 ${styles.footer_links}`}>
                        <div className='d-flex flex-column align-items-start justify-content-center mx-4'>
                            <div className={`mb-3 ${styles.text_gray}`}>
                                دسترسی سریع
                            </div>
                            <ul className='d-flex flex-column align-items-start justify-content-center p-0 m-0'>
                                <li className={`my-2 ${styles.text_black}`}>
                                    <Link to="/خرید" className={styles.link}>
                                        خرید
                                    </Link>
                                </li>
                                <li className={`my-2 ${styles.text_black}`}>
                                    <Link to="/رهن-و-اجاره" className={styles.link}>
                                        رهن و اجاره
                                    </Link>
                                </li>
                                <li className={`my-2 ${styles.text_black}`}>
                                    <Link to="/تماس-با-ما" className={styles.link}>
                                        تماس با ما
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div className='d-flex flex-column align-items-start justify-content-center mx-4 '>
                            <ul className='d-flex flex-column align-items-start justify-content-center p-0 m-0'>
                                <li className={`my-2 ${styles.text_black}`}>
                                    <Link to="/وبلاگ" className={styles.link}>
                                        بلاگ
                                    </Link>
                                </li>
                                <li className={`my-2 ${styles.text_black}`}>
                                    <Link to="/درباره-ما" className={styles.link}>
                                        درباره ما
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className={`d-flex flex-column align-items-start justify-content-center ${styles.footer_contact}`}>
                        <div className={`mb-3 mt-md-0 mt-2 ${styles.text_gray}`}>
                            ارتباط با ما
                        </div>
                        <div className='d-flex align-items-center my-2'>
                            <div className={`ms-2 ${styles.text_gray}`}>
                                ایمیل :
                            </div>
                            <div className={styles.text_black}>
                                {data?.email}
                            </div>
                        </div>
                        <div className='d-flex align-items-center my-2'>
                            <div className={`ms-2 ${styles.text_gray}`}>
                                شماره تماس :
                            </div>
                            <div className={styles.text_black}>
                                {data?.landlinePhone?.toString()?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                            </div>
                            <div className={styles.text_black}>
                                &nbsp; - &nbsp;
                            </div>
                            <div className={styles.text_black}>
                                {data?.phoeNumber?.toString()?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                            </div>
                        </div>
                        <div className='w-100 d-flex align-items-start justify-content-start my-2 mb-3 text-end'>
                            <div className={`ms-2 ${styles.text_gray}`}>
                                آدرس:
                            </div>
                            <div className={styles.text_black}>
                                {data?.address}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-100 mb-md-0 mb-3" style={{ height: "6px", background: "#FFFFFF" }}></div>
                <div className='w-100 d-flex flex-column flex-md-row align-items-center justify-content-center justify-content-md-between px-5 gap-3 text-end'>
                    <div className={styles.text_gray}>
                        تمامی حقوق این وبسایت متعلق به <b>آذرملک</b> می‌باشد.
                    </div>
                    <div className='d-flex align-items-center justify-content-between mt-2'>
                        <div className={`d-flex align-items-center justify-content-center ms-3 me-0 ${styles.link_logo_container}`}>
                            <a href={"https://t.me/" + data?.telegram}><img src={telIcon} alt="تلگرام" /></a>
                        </div>
                        {/*<div className={`d-flex align-items-center justify-content-center mx-3 ${styles.link_logo_container}`}>
                            <a href={data?.whatsApp}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="#818181" viewBox="0 0 16 16">
                                    <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
                                </svg>
                            </a>
                        </div>*/}
                        <div className={`d-flex align-items-center justify-content-center mx-3 ${styles.link_logo_container}`}>
                            <a href={"https://instagram.com/" + data?.instagram}><img src={instaIcon} alt="اینستاگرام" /></a>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Footer;